import React from "react";
import { observer } from "mobx-react-lite";
import { stores } from "../context";
import { useTranslation } from "react-i18next";

export const ThemeToggle = observer(() => {
  const { ui } = stores; // or const ui = stores.ui
  const { t } = useTranslation("common");

  return (
    <div className="flex items-center space-x-2 p-1 bg-gray-200 dark:bg-gray-700 rounded-full">
      <button
        title={t("theme.light")}
        onClick={() => ui.setTheme("light")}
        className={`p-1.5 rounded-full transition-colors ${
          ui.theme === "light"
            ? "bg-white text-gray-800 shadow"
            : "text-gray-500 hover:bg-gray-300 dark:text-gray-400 dark:hover:bg-gray-600"
        }`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-5 h-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.95-4.209l-1.591 1.591M5.25 12H3m4.209-4.95l-1.591-1.591M12 12a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z"
          />
        </svg>
      </button>
      <button
        title={t("theme.dark")}
        onClick={() => ui.setTheme("dark")}
        className={`p-1.5 rounded-full transition-colors ${
          ui.theme === "dark"
            ? "bg-gray-900 text-white shadow"
            : "text-gray-500 hover:bg-gray-300 dark:text-gray-400 dark:hover:bg-gray-600"
        }`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-5 h-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z"
          />
        </svg>
      </button>
      <button
        title={t("theme.system")}
        onClick={() => ui.setTheme("system")}
        className={`p-1.5 rounded-full transition-colors ${
          ui.theme === "system"
            ? "bg-blue-500 text-white shadow"
            : "text-gray-500 hover:bg-gray-300 dark:text-gray-400 dark:hover:bg-gray-600"
        }`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-5 h-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-1.621-.87a3 3 0 01-.879-2.122v-1.007M5.25 6.032l4.125 4.125m0 0l4.125 4.125M9.375 10.157l4.125-4.125m0 0l4.125 4.125M3 8.25V15.75a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 15.75V8.25"
          />
        </svg>
      </button>
    </div>
  );
});
